const my_profile = {
  viewMyClubSeacretProfile: "Δείτε το προφίλ μου ClubSeacret", // translated
  viewMoreDetails: "Δείτε περισσότερες λεπτομέρειες", // translated
  verifiedEmail: "Επαληθευμένο email", // translated
  unverifiedEmail: "Μη επαληθευμένο email", // translated
  createdFrom: "Δημιουργήθηκε από", // translated
  createdTo: "Δημιουργήθηκε έως", // translated
  selectStatus: "Επιλέξτε κατάσταση...", // translated
  searchByTitle: "Αναζήτηση με τίτλο...", // translated
  pushNotifications: "Push Ειδοποιήσεις",
  pushNotificationsDescription: "Λάβετε ειδοποιήσεις του προγράμματος περιήγησης για σημαντικές ενημερώσεις και συμβάντα",
  pushNotificationsNotSupported: "Οι push ειδοποιήσεις δεν υποστηρίζονται σε αυτό το πρόγραμμα περιήγησης",
  pushNotificationsDeniedMessage: "Η άδεια ειδοποίησης απορρίφθηκε. Παρακαλώ ενεργοποιήστε τις ειδοποιήσεις στις ρυθμίσεις του προγράμματος περιήγησης για να λάβετε push ειδοποιήσεις.",
  pushNotificationsEnabled: "Οι push ειδοποιήσεις ενεργοποιήθηκαν με επιτυχία",
  pushNotificationsDisabled: "Οι push ειδοποιήσεις απενεργοποιήθηκαν με επιτυχία",
  userInformationMissing: "Λείπουν πληροφορίες χρήστη",
  failedToUpdatePushNotifications: "Αποτυχία ενημέρωσης των ρυθμίσεων push ειδοποιήσεων",
  notificationPermissionDenied: "Η άδεια ειδοποίησης απορρίφθηκε. Παρακαλώ ενεργοποιήστε την στις ρυθμίσεις του προγράμματος περιήγησης.",
  notificationPermissionRequired: "Απαιτείται άδεια ειδοποίησης για να ενεργοποιηθούν οι push ειδοποιήσεις",
  notSupported: "Δεν υποστηρίζεται",
  permissionDenied: "Άδεια απορρίφθηκε",
  permissionNotRequested: "Άδεια δεν ζητήθηκε",
  enabled: "Ενεργοποιημένο",
  disabled: "Απενεργοποιημένο",
};

export default my_profile;
